export default {
  formId: 'editTipoNovedadForm', //'editTipoNovedadForm',
  formField: {
    e_name: {
      name: 'e_name',
      label: 'Nombre*',
      requiredErrorMsg: 'Nombre es requerido.',
    },
    e_description: {
      name: 'e_description',
      label: 'Descripcion*',
      requiredErrorMsg: 'Descripcion es requerido.',
    },
    e_accion_1: {
      name: 'e_accion_1',
      label: 'Accion 1*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    e_resultado_1: {
      name: 'e_resultado_1',
      label: 'Resultado 1*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    e_cantidad_1: {
      name: 'e_cantidad_1',
      label: 'Cantidad 1*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
    e_accion_2: {
      name: 'e_accion_2',
      label: 'Accion 2*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    e_resultado_2: {
      name: 'e_resultado_2',
      label: 'Resultado 2*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    e_cantidad_2: {
      name: 'e_cantidad_2',
      label: 'Cantidad 2*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
    e_accion_3: {
      name: 'e_accion_3',
      label: 'Accion 3*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    e_resultado_3: {
      name: 'e_resultado_3',
      label: 'Resultado 3*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    e_cantidad_3: {
      name: 'e_cantidad_3',
      label: 'Cantidad 3*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
    e_accion_4: {
      name: 'e_accion_4',
      label: 'Accion 4*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    e_resultado_4: {
      name: 'e_resultado_4',
      label: 'Resultado 4*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    e_cantidad_4: {
      name: 'e_cantidad_4',
      label: 'Cantidad 4*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
  },
};
